import EventEmitter from 'eventemitter3';
import { ws } from '~/common/js/futures/rx-wobsocket-futures';
import { useFuturesStore } from '~/store/futures';
// import * as Sentry from '@sentry/vue'

// const SENTRY_ENABLE =
//   process.env.NODE_ENV === 'production' && ['testing', 'production'].includes(process.env.domain_env)

export default defineNuxtPlugin((nuxtApp) => {
  const ee = new EventEmitter();
  const futuresStore = useFuturesStore();
  // let decoder

  const handleWsMessage = (msg) => {
    // let decodeData
    // if (ArrayBuffer.isView(msg.data)) {
    //   if (!decoder) {
    //     decoder = new TextDecoder()
    //   }
    //   decodeData = JSON.parse(decoder.decode(msg.data))
    // } else {
    //   decodeData = msg.data
    // }
    const { type, payload } = msg
    if (!ws.ws) {
      ws.connect()
    }
    switch (type) {
      case 'FUTURES_PRICE_LIST':
        futuresStore.UPDATE_SYMBOL_PRICE(payload);
        break;
    }
  }

  // function handleWsError(err) {
  //   SENTRY_ENABLE && Sentry.captureException(err)
  // }

  ws.on('postMessage', handleWsMessage)

  // ws.postMessage({
  //   type: WORKER_MSG_TOPIC.get('INIT'),
  //   payload: {
  //     env,
  //     query,
  //     params,
  //   },
  // })
  return {
    provide: {
      futuresWorker: {
        ws,
        ee,
      },
    },
  };
});
